import { render, staticRenderFns } from "./yundongku.vue?vue&type=template&id=00487e8f&scoped=true"
import script from "./yundongku.vue?vue&type=script&lang=ts"
export * from "./yundongku.vue?vue&type=script&lang=ts"
import style0 from "./yundongku.vue?vue&type=style&index=0&id=00487e8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00487e8f",
  null
  
)

export default component.exports